import assertNever from 'assert-never';

import { ProgressStatus } from '@shure/shared/angular/ui/components/ag-grid-next';
import { asLabel } from '@shure/shared/models';

export function mapProgressStatusToTranslocoKey(status: ProgressStatus): string {
	switch (status) {
		case ProgressStatus.InProgress:
			return asLabel('cloud.shared.status.in-progress');
		case ProgressStatus.Success:
			return asLabel('cloud.shared.status.success');
		case ProgressStatus.Error:
			return asLabel('cloud.shared.status.error');
		default:
			assertNever(status);
	}
}
